import React from 'react';
import { UNDO_BUTTON, REDO_BUTTON, TRACK_CHANGES_GROUP_RANK, TRACK_CHANGES_GROUP } from '@atlaskit/editor-common/toolbar';
import { RedoButton } from './RedoButton';
import { UndoButton } from './UndoButton';
export var getToolbarComponents = function getToolbarComponents(api) {
  return [{
    type: UNDO_BUTTON.type,
    key: UNDO_BUTTON.key,
    parents: [{
      type: TRACK_CHANGES_GROUP.type,
      key: TRACK_CHANGES_GROUP.key,
      rank: TRACK_CHANGES_GROUP_RANK[UNDO_BUTTON.key]
    }],
    component: function component() {
      return /*#__PURE__*/React.createElement(UndoButton, {
        api: api
      });
    }
  }, {
    type: REDO_BUTTON.type,
    key: REDO_BUTTON.key,
    parents: [{
      type: TRACK_CHANGES_GROUP.type,
      key: TRACK_CHANGES_GROUP.key,
      rank: TRACK_CHANGES_GROUP_RANK[REDO_BUTTON.key]
    }],
    component: function component() {
      return /*#__PURE__*/React.createElement(RedoButton, {
        api: api
      });
    }
  }];
};